import { IJobAdditionalAttributes } from "./JobRequest";
import type { IReportRejectSelectionConfig } from "./Report";
import { JobStatus } from "./JobStatus";

export interface IManualJobEntryInput {
    grain_count: string;
}

export interface IJob {
    createdAt: number;
    updatedAt?: number;
    username?: string;
    jobId: string;
    grainId: string;
    profileId: string;
    jobStatus: JobStatus;
    processingMode?: 'cloud' | 'local';
    input_object_key?: string;
    inputImagePath?: string;
    results?: IJobResult;
    info?: { [key: string]: any } | null;
    productName?: string;
    additionalAttributes?: IJobAdditionalAttributes;
    mlLabelingStatus?: string;
    txHash?: string;
    syncStatus?: 'pending' | 'syncing' | 'synced' | 'failed';
    syncError?: string;
    syncedAt?: number;
    syncAttempts?: number;
    lastSyncAttemptAt?: number;
    source?: string;
    location?: string;
}

export interface IQueueRequest {
    jobId: string;
}

export interface IOrgJobListItem {
    variety?: string;
    jobId: string;
    jobStatus: JobStatus;
    grainId: string;
    profileId?: string;
    username?: string;
    centerName?: string;
    createdAt: number;
    mlLabelingStatus?: string; 
}

export interface IUserJobListItem {
    jobId: string;
    variety?: string;
    jobStatus: JobStatus;
    grainId: string;
    profileId?: string;
    createdAt: number;
    updatedAt?: number;
    mlLabelingStatus?: string;
    processingMode?: 'cloud' | 'local';
    syncStatus?: 'pending' | 'syncing' | 'synced' | 'failed';
    syncError?: string;
    syncedAt?: number;
    source?: string;
    location?: string;
}

export interface IJobResult {
    avg_aspect_ratio: number;
    std_area_base: number;
    std_aspect_ratio: number;
    avg_width: number;
    avg_length: number;
    avg_length_of_broken_grains?: number;
    grain_count: number;
    whiteness_index?: number;
    std_width: number;
    avg_area_base: number;
    jobStatus: string;
    std_length: number;
    indi_grain_csv: string;
    rejection_analysis_csv: string;
    rejection_analysis_display_csv: string; // for L10 users
    labeled_image: string;
    good_grain_percent: number;
    rejection_percent: number;
    broken_percent?: number;
    particle_distribution_csv: string; // for L10 users
    particle_distribution_width_csv?: string;
    particle_distribution_area_csv?: string;
    cumulative_analysis_csv: string; // for L10 users
    scanned_images: string[];
    rejectionCalculationConfig?: IReportRejectSelectionConfig;
    local_files?: {
        indi_grain_csv_path?: string;
        rejection_analysis_csv_path?: string;
        rejection_analysis_display_csv_path?: string;
        labeled_image_path?: string;
        scanned_image_paths?: string[];
        particle_distribution_csv_path?: string;
        particle_distribution_width_csv_path?: string;
        particle_distribution_area_csv_path?: string;
        cumulative_analysis_csv_path?: string;
    };
}

export interface IJobs {
    Items: IJob[];
}

export interface IJobListTimestampRange {
    readonly from: number;
    readonly to: number;
}
